<template>
  <div v-if="contract">
    <div>
      <Details :watch="watch" :contract="contract" class=""/>
    </div>
  </div>
  <div v-else style="">
    <div class="card">
      <div class="card-body p-0 p-4" style="font-weight: 900;">
        Loading contract details <img class="loading-icon" src="img/spinner.svg"/>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-pretty/lib/styles.css';
import Details from './components/Details.vue';
import Parse from "@/helpers/Parse";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Contract",
  components: {
    Details
  },
  data() {
    return {
      address: '',
      contract: null,
      watch: null
    };
  },
  computed: {
    ...mapGetters({
      txConfig: 'transactions/config',
    })
  },
  watch: {
    async $route() {
      await this.init();
    }
  },
  beforeDestroy() {
  },
  async mounted() {
    await this.init();
  },
  methods: {
    ...mapActions({
    }),
    async fetchContract(address) {
      const contractQuery = Parse.getContractQuery();
      contractQuery.matches('address', address, 'i');
      contractQuery.ascending("createdAt");
      contractQuery.limit(1);
      const contracts = await contractQuery.find();//[=]-----

      if (contracts.length > 0) {
        if (contracts[0].get('totalSupply')) {
          return contracts[0];
        }
        await contracts[0].destroy();
      }
    },
    async init() {
      this.contract = null;
      this.address = this.$route.params.address;
      this.contract = await this.fetchContract(this.address);
    },
  },
};
</script>
<style scoped>
</style>